export default __webpack_public_path__ + "static/media/longhairguy.f16ca2cd.png";